<template>
  <div
    class="video-container pb-0 h-full w-full relative"
    :class="{ 'pl-0': fullDetails }"
  >
    <video
      ref="videoPlayer"
      class="rounded-lg w-full cursor-pointer"
      :class="
        fullDetails ? 'h-full object-contain' : 'MM-small-shorts h-[35vh] max-h-[40vh]'
      "
      :src="$props.url"
      muted
      loop
      controls
      controlslist="nodownload noremoteplayback"
      disablepictureinpicture
      @mouseover="playVideo"
      @mouseout="pauseVideo"
      @canplay="$emit('mediaLoaded')"
      @error="$emit('error')"
      @click="pauseOrPlay"
    >
      <source :src="$props.url" type="video/mp4" />
    </video>

    <div
      class="flex flex-col items-center justify-center pointer-events-none absolute inset-0 gap-2"
    >
      <i v-if="!isPlaying && !fullDetails" class="pi pi-play-circle text-4xl" />
      <p v-if="hasError" class="text-red-500">{{ $t("errors.tryAgain") }}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{ url: string; fullDetails?: boolean }>();

defineEmits(["mediaLoaded", "error"]);

const videoPlayer = ref<HTMLVideoElement | null>(null);
const isPlaying = ref(false);
const hasError = ref(false);
let initialized = false;

const playVideo = () => {
  if (props.fullDetails) {
    return;
  }
  videoPlayer.value?.play().catch(() => {
    hasError.value = true;
  });
};

const pauseVideo = () => {
  if (props.fullDetails) {
    return;
  }
  videoPlayer.value?.pause();
};
const pauseOrPlay = () => {
  if (!videoPlayer.value) {
    return;
  }
  if (videoPlayer.value.paused) {
    videoPlayer.value.play().catch(() => {
      hasError.value = true;
    });
  } else {
    videoPlayer.value.pause();
  }
};

watch(videoPlayer, player => {
  if (!player || initialized) return;
  player.onplay = () => {
    isPlaying.value = true;
  };
  player.onpause = () => {
    isPlaying.value = false;
  };
  player.onerror = () => {
    hasError.value = true;
  };
  initialized = true;
});
</script>

<style scoped>
video::-webkit-media-controls-fullscreen-button {
  opacity: 0;
}

video.MM-small-shorts::-webkit-media-controls {
  display: none;
}
</style>
